export class SettingValueItem {
  item: string;
  type: string;

  constructor(item: string, type: string) {
    this.item = item;
    this.type = type;
  }
}
